import type { NavLinkProps } from 'react-router-dom'

import PaymentRequiredLink from './payment-required-link'
import { PremiumFeatures } from '../../../store/types/billing'

export default function ReportLink({
  reportType,
  ...props
}: NavLinkProps & {
  reportType: 'Category Report' | 'Brand Report'
}): JSX.Element {
  return (
    <PaymentRequiredLink
      allowed={PremiumFeatures}
      feature={reportType}
      {...props}
    />
  )
}
